import * as React from 'react';
import type Slider from 'react-slick';

import { Button, StyleSheet, color, css } from '@coursera/coursera-ui';
import { SvgChevronLeft, SvgChevronRight } from '@coursera/coursera-ui/svg';

import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

type Props = {
  onClick?: () => void;
  isArrowRight?: boolean;
  slider: Slider | null;
  length: number;
  slidesToShowLength: number;
  className?: string;
};

const TrackedArrowButton = withSingleTracked({ type: 'BUTTON' })(Button);

const CONFIG = { horizontalOffset: 40, top: '40%' };

const styles = StyleSheet.create({
  leftArrow: {
    position: 'absolute',
    top: CONFIG.top,
    left: -CONFIG.horizontalOffset,
    padding: 0,
    zIndex: 1,
  },
  rightArrow: {
    position: 'absolute',
    top: CONFIG.top,
    right: -CONFIG.horizontalOffset,
    padding: 0,
    zIndex: 1,
  },
});

class ArrowButton extends React.Component<Props> {
  handleClick = () => {
    const { onClick, isArrowRight, slider, length, slidesToShowLength } = this.props;

    if (onClick) {
      onClick();
    } else if (isArrowRight && slider) {
      // fix infinite slider when on last slide
      slider.slickGoTo(0);
    } else if (slider) {
      // fix infinite slider when on first slide
      const lastSlidePosition = length - (length % slidesToShowLength);
      slider.slickGoTo(lastSlidePosition);
    }
  };

  render() {
    const { isArrowRight, className, ...rest } = this.props;
    // Chevron color based on recommendation from design.
    // For more context, see ticket comment section - https://coursera.atlassian.net/browse/ACCESS-754
    const chevronColor = '#3b3b3b';
    const disabled = !!className?.includes('slick-disabled');

    if (disabled) {
      return null;
    }

    return (
      <div
        {...css(
          isArrowRight ? 'arrow-button-next' : 'arrow-button-prev',
          isArrowRight ? styles.rightArrow : styles.leftArrow
        )}
      >
        <TrackedArrowButton
          type="icon"
          trackingName={isArrowRight ? 'recommendation_slider_arrow_right' : 'recommendation_slider_arrow_left'}
          htmlAttributes={{
            'aria-label': isArrowRight ? _t('go to next slide') : _t('go to previous slide'),
          }}
          {...rest}
          onClick={this.handleClick}
          style={{ padding: 0 }}
        >
          {isArrowRight ? (
            <SvgChevronRight size={48} color={chevronColor} hoverColor={color.lightGrayText} suppressTitle={true} />
          ) : (
            <SvgChevronLeft size={48} color={chevronColor} hoverColor={color.lightGrayText} suppressTitle={true} />
          )}
        </TrackedArrowButton>
      </div>
    );
  }
}

export default ArrowButton;
